import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "./Reveal";
import { ABOUT, PROFILE } from "../../data/content";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" ref={ref} className="relative bg-[#0c2c20] py-28 md:py-40">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-14 px-6 md:px-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Overline>01 — The Human</Overline>
            <div className="relative mt-8 overflow-hidden">
              <motion.img
                style={{ y }}
                src={PROFILE.portrait}
                alt="Naresh Gabriel portrait"
                className="aspect-[4/5] w-full scale-110 object-cover object-top grayscale contrast-110"
              />
              <div className="absolute inset-0 border border-white/10" />
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal>
            <h2 className="font-display text-4xl font-bold leading-[1.05] text-white sm:text-5xl lg:text-6xl">
              Strategic thinking,
              <span className="text-[#52525b]"> practical execution.</span>
            </h2>
          </Reveal>
          <div className="mt-10 space-y-6">
            {ABOUT.map((p, i) => (
              <Reveal key={i} delay={0.08 * i}>
                <p className="text-[15px] leading-relaxed text-[#a1a1aa] md:text-lg">{p}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-12 flex flex-wrap gap-x-12 gap-y-6 border-t border-white/10 pt-8">
              <div>
                <p className="font-display text-3xl text-white">5</p>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[#52525b]">Industries</p>
              </div>
              <div>
                <p className="font-display text-3xl text-white">3</p>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[#52525b]">Continents</p>
              </div>
              <div>
                <p className="font-display text-3xl text-white">15+</p>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[#52525b]">Years leading</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
